import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import cn from 'classnames';
import { useCallback } from 'react';
import { Link } from '../Router/Link/Link.js';
import { isBrowser } from '../../tools/env.js';
import 'nanoid';
import '../../tools/dom.js';
import 'timen';
import 'compareq';
import 'lodash.pick';
import '../../tools/queryParams.js';
import S from './Text.styl.js';

const textToAnchorId = text => text.toLowerCase().split(' ').join('_');
const getPath = () => (isBrowser && location.pathname) ?? '/';
const scrollIntoHeader = id => document.getElementById(id)?.scrollIntoView();
function useAnchor(text) {
    if (typeof text !== 'string')
        return [];
    const id = textToAnchorId(text);
    const href = `${getPath()}#${id}`;
    const scrollUp = useCallback(() => scrollIntoHeader(id), [id]);
    return [
        id,
        jsxs(Fragment, { children: ["\u00A0", jsx(Link, { href: href, className: S.anchor, onClick: scrollUp, children: "#" })] }),
    ];
}
function H({ As, className, children, anchor, ...rest }) {
    const [id, anchorEl] = useAnchor(anchor ?? children);
    return (jsxs(As, { ...rest, className: cn(S.heading, className), id: id, children: [children, anchorEl] }));
}
const H1 = props => jsx(H, { ...props, As: "h1", anchor: false });
const H2 = props => jsx(H, { ...props, As: "h2" });
const H3 = props => jsx(H, { ...props, As: "h3" });
const H4 = props => jsx(H, { ...props, As: "h4" });
const H5 = props => jsx(H, { ...props, As: "h5" });
const H6 = props => jsx(H, { ...props, As: "h6" });
if (isBrowser) {
    window.addEventListener('load', () => {
        scrollIntoHeader(location.hash.slice(1));
    });
}

export { H1, H2, H3, H4, H5, H6 };
